import { SuccessConfetti } from "common/Icons/Icons.tsx";
import Title from "common/Typography/Title.tsx";
import Text from "common/Typography/Text.tsx";
import InvitingUserSummary from "features/configuration/InviteExternalUsers/InvitingUserSummary.tsx";
import styled from "styled-components";
import useMedia from "utils/hooks/useMedia.ts";
import { MOBILE_SEARCH } from "common/constants.ts";
import { useWindowSize } from "react-use";

const SuccessPage = () => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { height } = useWindowSize();

  return (
    <Wrapper>
      <InnerWrapper style={{ marginTop: -(height / 8) }}>
        <SuccessConfetti
          style={{
            width: isMobile ? 150 : 260,
            height: "auto",
            marginBottom: 16,
          }}
        />
        <Title level={isMobile ? 2 : 1} style={{ textAlign: "center" }}>
          Account Connected Successfully
        </Title>
        <Text type="secondary" style={{ margin: "8px 0" }}>
          Your account was successfully connected to the following Cornix user:
        </Text>
        <InvitingUserSummary hideBg={true} style={{ width: 250 }} />
        <Text type="secondary" style={{ marginTop: 20 }}>
          If you wish to revoke access to your exchange account at any time you
          can always delete your API key directly in your exchange account.
        </Text>
      </InnerWrapper>
    </Wrapper>
  );
};

export default SuccessPage;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
`;
